<bepatient-video *ngIf="video" [video]="video"></bepatient-video>
